function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime/helpers/arrayWithHoles.js
 ** module id = 691
 ** module chunks = 0
 **/